import React ,{useState , useEffect}from 'react'
import { BASE_URL } from '../Config/Config';
import { Useglobelcontext } from '../component/blogcontext/Blogcontext';
import { UseGlobellogin } from '../component/Logincontaxt.jsx/Logincontex';
import { useLocation, useNavigate } from 'react-router-dom';
function Course_Reviwe({courseid}) {
      const [review , setreview] = useState([]);
      const navigate = useNavigate();
      const location = useLocation();
      const {seterrormessage , setsuccessfully , userName , userEmail , userId , isLoggedIn  } =  UseGlobellogin();
       const [postreview ,setpostreview] = useState({
        CourseReview_remark : "",
        CourseReview_name: userName? userName:"",
        CourseReview_email: userEmail ? userEmail : "",
        CourseRevie_user_id:userId,
       }); 
console.log("courseid",courseid)

       const getData = async () => {
         try {
           const response = await fetch(`${BASE_URL}/coursereview/`, {
             method: 'GET',
             headers: {
               'Content-Type': 'application/json',
             },
             credentials: 'include', 
           });
           const data = await response.json(); 
              setreview(data.data);
         } catch (error) {
           console.error('Error fetching reviews:', error);

         }
       };

   useEffect(() => {
        getData(); 
    }, []);
      
      


const submitreview = async () => {
  console.log("courseid",courseid)
   if(isLoggedIn){
       navigate('/login', { state: { from: location } });

   }
   else{

   

  const requestBody = {
    ...postreview,
    CourseReview_Course_id: courseid,
    status: 1,
  };

  try {
    const response = await fetch(`${BASE_URL}/coursereview/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    });

    console.log("Submitted Review Data:", requestBody);

    const reviewdata = await response.json();

    if (response.ok) {
      setsuccessfully(reviewdata.message);
     getData(); 
      // Reset form fields
      setpostreview({
        CourseReview_remark: "",
        CourseReview_name: userName ? userName : "",
        CourseReview_email: userEmail ? userEmail : "",
        CourseRevie_user: userId,
      });

      setTimeout(() => {
        setsuccessfully("");
      }, 5000);
    } else {
      seterrormessage(reviewdata.message || "Something went wrong.");
    }

  } catch (error) {
    console.error("Review Submission Error:", error);
    seterrormessage(error.message || "Network error");
  }
  }
};


    const updateInput = (event)=>{
      const name = event.target.name;
      const value = event.target.value;
         setpostreview({
              ...postreview,
               [name]:value,
          })
    }


  return (
   <>
    <div className="course-Reviews">
                     <div className="th-comments-wrap ">
                       <ul className="comment-list">
   
                      {review.map((curdata , index)=>(
                         <li className="review th-comment-item" key={index}>
                           <div className="th-post-comment">
                             <div className="comment-avater">
                               <img src="https://i.pinimg.com/originals/f9/b0/6e/f9b06eea4f4f576ca92fa2f35e6206f7.jpg" alt="Comment Author" />
                             </div>
   
                             <div className="comment-content">
                               <h4 className="name">{curdata.CourseReview_name}</h4>
<span className="commented-on">
  <i className="fal fa-calendar-alt" />{" "}
  {new Date(curdata.create_date).toLocaleDateString("en-US", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  })}
</span>
                               
                               <div className="star-rating" role="img" aria-label="Rated 5.00 out of 5">
                                 <span style={{width: '100%'}}>Rated <strong className="rating">5.00</strong> out of 5 based on <span className="rating">1</span> customer rating</span>
                               </div>
                               <p className="text">{curdata?.CourseReview_remark}</p>
                             </div>
                           </div>
                         </li>
                        ))} 
                       </ul>
                     </div> 



                     {/* Comment Form */}
                     <div className="th-comment-form ">
                       <div className="form-title">
                         <h3 className="blog-inner-title ">Add a review</h3>
                       </div>
   
                       <div className="row">
   
                         {/* <div className="form-group rating-select d-flex align-items-center">
                           <label>Your Rating</label>
                           <p className="stars">
                             <span>
                               <a className="star-1" href="#">1</a>
                               <a className="star-2" href="#">2</a>
                               <a className="star-3" href="#">3</a>
                               <a className="star-4" href="#">4</a>
                               <a className="star-5" href="#">5</a>
                             </span>
                           </p>
                         </div> */}
                         <div className="col-12 form-group">
                           <textarea placeholder="Write a Message"
                           className="form-control"
                           onChange={updateInput}
                           name='CourseReview_remark'
                           value={postreview.CourseReview_remark}
                           required
                           // defaultValue={""}
                            />
                           <i className="text-title far fa-pencil-alt" />
                         </div>
   
                         <div className="col-md-6 form-group">
                           <input type="text" 
                           placeholder="Your Name"
                           onChange={updateInput}
                           name='CourseReview_name'
                           required
                           value={postreview.CourseReview_name}
                           className="form-control" />
                           <i className="text-title far fa-user" />
                         </div>
   
                         <div className="col-md-6 form-group">
                           <input type="email" 
                           onChange={updateInput}
                           value={postreview.CourseReview_email}
                           placeholder="Your Email"
                           name='CourseReview_email'
                           required
                           className="form-control" />
                           <i className="text-title far fa-envelope" />
                         </div>
   
                         {/* <div className="col-12 form-group">
                           <input id="reviewcheck" 
                           name="reviewcheck" 
                           type="checkbox" />
                           <label htmlFor="reviewcheck">Save my name, email, and website in this browser for the next time I comment.<span className="checkmark" /></label>
                         </div> */}
                         
                      {/* {FormMessage && (
                         <div style={{fontSize:"1.3rem" , color:"green" ,marginBottom:"1rem"}}>
                         {FormMessage}
                        </div>
                            )} */}
                         <div className="col-12 form-group mb-0">
                           <button className="th-btn" onClick={submitreview}>Post Review <i className="far fa-arrow-right ms-1" /></button>
                         </div>
                        </div>
                       </div>
                     </div>
   
   
   </>
  )
}

export default Course_Reviwe